import { User } from '@/kernel/collections/user';
import { Organisation } from '@/kernel/collections/organisation';
import { Theme } from '@/kernel/collections/theme';
import { Objective } from '@/kernel/collections/objective';
import { Source } from '@/kernel/collections/source';
import { PlatformAsset } from '@/kernel/collections/platform-asset';
import { PlatformAssetManager } from '@/kernel/collections/platform-asset-manager';
import { OrganisationAsset } from '@/kernel/collections/organisation-asset';
import { OrganisationAssetManager } from '@/kernel/collections/organisation-asset-manager';
import { AssessmentTemplate } from '@/kernel/collections/assessment-template';
import { Assessment } from '@/kernel/collections/assessment';
import { Announcement } from '@/kernel/collections/announcement';

const collections = {
  'user': User,
  'organisation': Organisation,
  'theme': Theme,
  'objective': Objective,
  'source': Source,
  'platform-asset': PlatformAsset,
  'platform-asset-manager': PlatformAssetManager,
  'organisation-asset': OrganisationAsset,
  'organisation-asset-manager': OrganisationAssetManager,
  'assessment-template': AssessmentTemplate,
  'assessment': Assessment,
  'announcement': Announcement
}

export const getCollections = () => {
  return Object.keys(collections).map(getCollection);
}

export const getCollection = (key) => {
  return new collections[key];
}
